import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, CardMedia, Button, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

const BlogCarousel = ({ blogsData, title = 'Explore Our Latest Blog Posts' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? blogsData.length - (window.innerWidth < 600 ? 1 : 2) : prevIndex - (window.innerWidth < 600 ? 1 : 2)
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex >= blogsData.length - (window.innerWidth < 600 ? 1 : 2) ? 0 : prevIndex + (window.innerWidth < 600 ? 1 : 2)
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: { xs: '2rem 1rem', md: '3rem 1rem' },
        background: 'linen',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '1.2rem', sm: '1.8rem' },
          textAlign: 'center',
          mb: 3,
          color: 'orangered',
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '1000px',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={handlePrevious}
          sx={{
            color: 'orangered',
            position: 'absolute',
            left: { xs: '-5px', sm: '-40px' },
            zIndex: 10,
            display: { xs: 'none', sm: 'block' },
          }}
        >
          <ArrowBackIos fontSize="large" />
        </IconButton>

        <Box sx={{ display: 'flex', overflow: 'hidden', justifyContent: 'center', width: '100%' }}>
          {blogsData.slice(currentIndex, currentIndex + (window.innerWidth < 600 ? 1 : 2)).map((blog) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              style={{ padding: '0 8px' }} // Reduced padding for better spacing on mobile
            >
              <Card
                sx={{
                  minWidth: { xs: '90%', sm: '350px' }, // Makes cards fit well in mobile
                  maxWidth: { xs: '100%', sm: '350px' },
                  backgroundColor: '#222',
                  borderRadius: '16px',
                  boxShadow: '0 8px 30px rgba(255, 69, 0, 0.5)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': { boxShadow: '0 12px 40px rgba(255, 69, 0, 0.7)', transform: 'translateY(-5px)' },
                }}
              >
                <CardMedia component="img" image={blog.image} alt={blog.title} sx={{ height: '200px', objectFit: 'cover' }} />
                <CardContent sx={{ padding: '16px', textAlign: 'center', color: 'white', backgroundColor: '#fff', }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', mb: 1, color: 'orangered' }}>
                    {blog.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#bbb', mb: 2 }}>
                    {blog.description.length > 70 ? `${blog.description.slice(0, 70)}...` : blog.description}
                  </Typography>
                  <Button
                    variant="contained"
                    disabled
                    sx={{
                      background: 'orangered',
                      fontSize: '0.85rem',
                      padding: '8px 20px',
                      borderRadius: '8px',
                      '&:hover': { background: '#ff4500cc' },
                    }}
                    onClick={() => window.open(blog.link, '_blank')}
                  >
                    Read More
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </Box>

        <IconButton
          onClick={handleNext}
          sx={{
            color: 'orangered',
            position: 'absolute',
            right: { xs: '-5px', sm: '-40px' },
            zIndex: 10,
            display: { xs: 'none', sm: 'block' }, // Hide buttons on small screens
          }}
        >
          <ArrowForwardIos fontSize="large" />
        </IconButton>
      </Box>

      {/* Mobile Buttons Below Cards */}
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          justifyContent: 'space-between',
          width: '100%',
          mt: 2,
        }}
      >
        <IconButton onClick={handlePrevious} sx={{ color: 'orangered' }}>
          <ArrowBackIos />
        </IconButton>
        <IconButton onClick={handleNext} sx={{ color: 'orangered' }}>
          <ArrowForwardIos />
        </IconButton>
      </Box>
    </Box>
  );
};

export default BlogCarousel;
